import { StateCreator } from "zustand";
import { ReportDetailState, SectionListRecordsItem, RelacoesSectionListItem } from "../interface";

export interface UIActions {
  setSectionListRecords: (records: SectionListRecordsItem[]) => void;
  setRelacoesSectionList: (list: RelacoesSectionListItem[]) => void;
  setTotalRecords: (total: number) => void;
  forceReload: () => void;
  setActionLoading: (loading: boolean) => void;
  setActiveSection: (sectionKey: string | null) => void;
  setScrollLoading: (loading: boolean) => void;
  setAccordionToggle: (toggle: ((sectionTitle: string) => void) | null) => void;
  setPendingScrollTarget: (target: string | null) => void;
  setOpenSections: (sections: string[]) => void;
  toggleOpenSection: (sectionId: string) => void;
  addOpenSection: (sectionId: string) => void;
  setOpenSectionsTrash: (sections: string[]) => void;
  toggleOpenSectionTrash: (sectionId: string) => void;
  addOpenSectionTrash: (sectionId: string) => void;
  setActiveRelacaoTab: (tab: 'semactic-analysis' | 'relationship-flow') => void;
  setHighlightedEntityId: (entityId: string | null) => void;
  setRefetchReport: (refetch: (() => Promise<any>) | null) => void;
}

export const createUIActions: StateCreator<
  ReportDetailState & { actions: any },
  [],
  [],
  UIActions
> = (set) => ({
  setSectionListRecords: (sectionListRecords) =>
    set((state) => ({
      ui: { ...state.ui, sectionListRecords },
    })),

  setRelacoesSectionList: (relacoesSectionList) =>
    set((state) => ({
      ui: { ...state.ui, relacoesSectionList },
    })),

  setTotalRecords: (totalRecords) =>
    set((state) => ({
      ui: { ...state.ui, totalRecords },
    })),

  forceReload: () =>
    set((state) => ({
      ui: { ...state.ui, reloadTrigger: state.ui.reloadTrigger + 1 },
    })),

  setActionLoading: (loading) =>
    set((state) => ({
      ui: { ...state.ui, isActionLoading: loading },
    })),

  setActiveSection: (sectionKey) =>
    set((state) => ({
      ui: { ...state.ui, activeSection: sectionKey },
    })),

  setScrollLoading: (loading) =>
    set((state) => ({
      ui: { ...state.ui, isScrollLoading: loading },
    })),

  setAccordionToggle: (toggle) =>
    set((state) => ({
      ui: { ...state.ui, accordionToggle: toggle },
    })),

  setPendingScrollTarget: (target) =>
    set((state) => ({
      ui: { ...state.ui, pendingScrollTarget: target },
    })),

  setOpenSections: (sections) =>
    set((state) => ({
      ui: { ...state.ui, openSections: sections },
    })),

  toggleOpenSection: (sectionId) =>
    set((state) => ({
      ui: {
        ...state.ui,
        openSections: state.ui.openSections.includes(sectionId)
          ? state.ui.openSections.filter((id) => id !== sectionId)
          : [...state.ui.openSections, sectionId],
      },
    })),

  addOpenSection: (sectionId) =>
    set((state) => ({
      ui: {
        ...state.ui,
        openSections: state.ui.openSections.includes(sectionId)
          ? state.ui.openSections
          : [...state.ui.openSections, sectionId],
      },
    })),

  setOpenSectionsTrash: (sections) =>
    set((state) => ({
      ui: { ...state.ui, openSectionsTrash: sections },
    })),

  toggleOpenSectionTrash: (sectionId) =>
    set((state) => ({
      ui: {
        ...state.ui,
        openSectionsTrash: state.ui.openSectionsTrash.includes(sectionId)
          ? state.ui.openSectionsTrash.filter((id) => id !== sectionId)
          : [...state.ui.openSectionsTrash, sectionId],
      },
    })),

  addOpenSectionTrash: (sectionId) =>
    set((state) => ({
      ui: {
        ...state.ui,
        openSectionsTrash: state.ui.openSectionsTrash.includes(sectionId)
          ? state.ui.openSectionsTrash
          : [...state.ui.openSectionsTrash, sectionId],
      },
    })),

  setActiveRelacaoTab: (tab) =>
    set((state) => ({
      ui: { ...state.ui, activeRelacaoTab: tab },
    })),

  setHighlightedEntityId: (entityId) =>
    set((state) => ({
      ui: { ...state.ui, highlightedEntityId: entityId },
    })),

  setRefetchReport: (refetch) =>
    set((state) => ({
      ui: { ...state.ui, refetchReport: refetch },
    })),
});
